export function canViewFinance(personel) {
  if (!personel) return false;
  if (personel.rol === 'admin') return true;
  if (personel.yetkiler?.moduller?.includes('FİNANS')) return true;
  return Boolean(personel.yetkiler?.ozelIzinler?.finansGoruntuleme);
}

/**
 * Maliyet kuralı yazma, Firestore Rules ile aynı kaynaktan gelir:
 * kullanicilar/{auth.uid}.rol == 'admin' (branchAuthIsAdmin).
 * personeller.ozelIzinler.finansMaliyetYonetimi Rules'ta doğrulanamaz
 * (şube Auth uid paylaşılır). Bu yüzden UI da o izne güvenmez.
 */
export function canManageFinanceCost(personel, { branchAuthIsAdmin } = {}) {
  return Boolean(branchAuthIsAdmin);
}
